The original request for the `WebhookSubscriptionReplay`.
